import styled from 'styled-components';
import { Carousel } from 'antd';

import { Colors, MediaQueryBreakpoints } from '@rockalingua/ui';

export const Container = styled.div`
  width: 100%;
  padding: 48p 0x;
`;

export const StyledCarousel = styled(Carousel)`
  .slick-dots li {
    width: 16px;
    height: auto;
    margin-right: 8px;
    margin-left: 8px;

    button {
      background-color: ${Colors.NEUTRAL_VARIANTS[30]};
      width: 16px;
      height: 16px;
      border-radius: 50%;
    }

    &.slick-active {
      width: 16px;

      button {
        background-color: ${Colors.BLUE};
      }
    }
  }
`;

export const CarouselItemContainer = styled.div`
  padding: 0px 24px 80px 24px;
`;

export const CarouselItem = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${Colors.NEUTRAL_VARIANTS[40]}33;
  border-radius: 18px;
  padding: 24px;
  background: white;
  box-shadow:
    0px 4px 9px 0px #171a1f1c,
    0px 0px 2px 0px #171a1f1f;
  gap: 24px;
`;

export const DescriptionContainer = styled.div`
  flex: 1;
  min-height: 150px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    min-height: 220px;
  }
`;

export const NameAndTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const QuoteIcon = styled.img`
  align-self: flex-end;
  width: 104px;
  height: 80px;
`;
